import TopLogoComponent from '../../assets/1x/logos_banner.png';

export const Logo = () => {
  return (
    <div className="snn-top-menu-logo-wrapper">
      <img
        src={TopLogoComponent}
        alt="Symposium of Nanoscience and Nanotechnology Logo"
        className="snn-top-menu-logo"
      />
    </div>
  );
};
